import { baseUrl } from "../config/config";
import axios from 'axios';

// get all Theme
export const getAllTheme = async () => {
  try {
    const response = await axios.get(`${baseUrl}/theme`);
    return response.data;
  } catch (error) {
    console.error('erreur get all Theme:', error);
    return error;
  }
}

// get Theme by Id
export const getThemeById = async (id) => {
  try {
    const response = await axios.get(`${baseUrl}/theme/${id}`);
    return response.data;
  } catch (error) {
    console.error(`erreur get Theme by Id ${id}:`, error);
    return error;
  }
}

// add Theme
export const addTheme = async (nomTheme) => {
  try {
    const response = await axios.post(`${baseUrl}/theme`, {nomTheme : nomTheme});
    return response;
  } catch (error) {
    console.error("erreur lors de l'ajout du Theme", error);
    console.log(error.response); // Ajoutez cette ligne pour afficher l'erreur détaillée
    return error;
  }
};


// update Theme by Id
export const updateThemeById = async (id, nomTheme) => {
  try {
    const response = await axios.put(`${baseUrl}/theme/${id}`, {nomTheme: nomTheme}, {
      headers:{
        'Cache-Control':'no-cache'
      }
    });
    return response.data;
  } catch (error) {
    console.error(`erreur lors de la modification du Theme by id ${id}:`, error);
    return error;
  }
}

// delete Theme by Id
export const deleteThemeById = async (id) => {
  try {
    const response = await axios.delete(`${baseUrl}/theme/${id}`);
    return response;
  } catch (error) {
    console.error(`erreur lors de la supression du Theme ${id}:`, error);
    return null;
  }
}
